import { max, min, reduce, add, curry } from 'ramda';

export const fitInRange = curry((min: number, max: number, value: number): number => {
  if (value < min) {
    return min;
  }

  if (value > max) {
    return max;
  }

  return value;
});

export interface IRect {
  width: number;
  height: number;
}

export const isInRange = curry((min: number, max: number, value: number): boolean => value >= min && value <= max);

export const getRectFitScale = (rect1: IRect, rect2: IRect): number =>
  min(rect1.width / rect2.width, rect1.height / rect2.height);

export const getRectFillScale = (rect1: IRect, rect2: IRect): number =>
  max(rect1.width / rect2.width, rect1.height / rect2.height);

export const floorWithPrecision = (value: number, precision = 0): number => {
  if (precision === 0) {
    return Math.floor(value);
  }

  const tenPower = Math.pow(10, precision);

  return Math.floor(value * tenPower) / tenPower;
};

export const arraySum: (array: number[]) => number = reduce(add, 0);

export const roundTo = (value: number, precision: number): number => {
  const period = Math.pow(10, precision);

  return Math.round(value * period) / period;
};

export const rotate = (rad: number, rect: IRect): IRect => {
  const cosRad = Math.cos(rad);
  const sinRad = Math.sin(rad);

  return {
    width: rect.width * cosRad - rect.height * sinRad,
    height: rect.width * sinRad + rect.height * cosRad,
  };
};
